import React from 'react';
import classes from './style.module.css'
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { passStringToDateWithFormat } from '../../../util/date/date-utils'
import { getPreviousNthDayStr } from '../../../util/date/date-utils'
import { currentDateStr } from '../../../util/date/date-utils'

const DatePicker = props => {

   return (
       <div className={classes.DatePicker} style={{width: '100%'}}>
                <div style={{color: 'white'}}>Date : </div>
                <div style={{marginLeft: '10px'}}>
                <div style={{position: 'fixed', zIndex: 100}} >
                <ReactDatePicker className={classes.ReactDatePicker}
                    dateFormat="yyyy/MM/dd"
                    selected={passStringToDateWithFormat(props.selectedDate, 'YYYYMMDD')}
                    minDate={passStringToDateWithFormat(getPreviousNthDayStr(14), 'YYYYMMDD')}
                    maxDate={passStringToDateWithFormat(currentDateStr(), 'YYYYMMDD')}
                    onChange={(event) => props.selectedDateChanged(event)} 
                    />
                
                </div>
                </div>
       </div>
   );
}

export default DatePicker;